import { render, staticRenderFns } from "./Recievables.vue?vue&type=template&id=796e4c10&scoped=true&"
import script from "./Recievables.vue?vue&type=script&lang=js&"
export * from "./Recievables.vue?vue&type=script&lang=js&"
import style0 from "./Recievables.vue?vue&type=style&index=0&id=796e4c10&scoped=true&lang=css&"
import style1 from "./Recievables.vue?vue&type=style&index=1&id=796e4c10&scoped=true&lang=css&"
import style2 from "./Recievables.vue?vue&type=style&index=2&id=796e4c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e4c10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VDataTable,VDivider,VIcon,VProgressLinear})
